var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',[_c('vue-apex-charts',{attrs:{"type":"line","height":"242","options":_vm.adequacaoChartData.lineChartSimple.chartOptions,"series":_vm.adequacaoChartData.lineChartSimple.series}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }